<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.55556L3.55556 8L8 12.4444L12.4444 8L8 3.55556ZM10.5588 8L8 10.5588L5.44117 8L8 5.44117L10.5588 8Z" fill="currentColor" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 8L8 16L16 8L8 0L0 8ZM14.1144 8L8 14.1144L1.88562 8L8 1.88562L14.1144 8Z" fill="currentColor" />
</svg>
